<template>
  <v-card flat class="px-3">
    <v-col
      cols="12"
      class="body-bold-smaller py-0"
    >
      <a type="primary" size="xsmall" @click="beforeLeave">
        <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
        {{ $t('message.actions.return') }}
      </a>
    </v-col>
    <v-col cols="12" class="pt-1 py-0">
      <span class="body-bold-medium" style="vertical-align: middle">
        {{ $t('message.pandaVideoPIP') }}
      </span>
    </v-col>
    <v-row no-gutters class="py-0 px-3">
      <v-col cols="12">
        <v-card flat>
          <span class="body-regular-smaller neutral-40-light--text"
            >{{ $t('message.pages.video.messagePIP') }}
            <a
              target="_blank"
              type="secondary"
              :href="$t('message.pages.video.knowMorePIPHref')"
            >
              <span>
                {{ $t('message.embedModal.knowMore') }}
              </span>
              <v-icon size="12">mdi-open-in-new</v-icon>
            </a></span
          >
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters class="pt-8 px-0">
          <v-col cols="12">
            <v-card flat>
              <span class="body-bold-base">
                {{ $t('message.pages.video.pipSettings') }}
              </span>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-3 px-0">
          <v-col cols="8">
            <v-card flat style="display: grid">
              <span class="body-regular-small neutral-20-dark--text">
                {{ $t('message.pages.video.openConfigPIP') }}
              </span>
              <span
                class="body-regular-smaller neutral-40-light--text"
                style="width: 60%"
                v-html="$t('message.pages.video.openConfigPIPText')"
              ></span>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-row justify="end" class="pt-8 pr-4">
              <base-btn type="secondary" size="small" @click="openEmbed">
                {{ $t('message.actions.config') }}
              </base-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters class="px-0" style="padding-top: 40px">
          <v-col cols="12">
            <v-card flat>
              <span class="body-bold-base">
                {{ $t('message.pages.video.demoPIP') }}
              </span>
              <img
                style="border-radius: 4px"
                class="mt-2"
                src="../../../assets/demo-scrollfollow.gif"
                width="70%"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  name: 'VideoPlayerPIP',
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
  },
  data: () => ({}),
  async mounted() {},
  methods: {
    beforeLeave() {
      this.handleBack()
    },
    openEmbed() {
      this.$root.$emit('openEmbedModal', { tab: 1, target: 'pip-scroll-flow' })
    },
    handleGoToArticle() {
      const articleLink = 'https://help.pandavideo.com/pt-br/'
      window.open(articleLink, '_blank')
    },
  },
}
</script>
<style></style>
